import Button from '@/features/ui/buttons/components/Button'
import { FC, memo } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

interface ActionButtonsProps {
    showDelete: boolean
    confirmDisabled: boolean
    onConfirm: () => void
    onCancel: () => void
    onDelete: () => void
}

const ActionButtons: FC<ActionButtonsProps> = ({
    showDelete,
    confirmDisabled,
    onConfirm,
    onCancel,
    onDelete,
}) => {
    const { t } = useTranslation()

    return (
        <View style={styles.container}>
            <Button
                disabled={confirmDisabled}
                color="secondary"
                onPress={onConfirm}
                textStyle={styles.buttonText}
                style={styles.button}
            >
                {t('actions.confirm')}
            </Button>
            <Button
                color="secondary"
                type="outline"
                onPress={onCancel}
                textStyle={styles.buttonText}
                style={styles.button}
            >
                {t('actions.close')}
            </Button>
            {showDelete && (
                <Button
                    onPress={onDelete}
                    color="primary"
                    textStyle={styles.buttonText}
                    style={styles.button}
                >
                    {t('actions.delete')}
                </Button>
            )}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        gap: 16,
        paddingTop: 8,
        width: '100%',
    },
    button: {
        borderRadius: 8,
        justifyContent: 'center',
    },
    buttonText: {
        textTransform: 'uppercase',
    },
})

export default memo(ActionButtons)
